import { render, staticRenderFns } from "./commPanel.vue?vue&type=template&id=d8402ffc&"
import script from "./commPanel.vue?vue&type=script&lang=js&"
export * from "./commPanel.vue?vue&type=script&lang=js&"
import style0 from "./commPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports